/**
 * 请求超时时间
 */
export var TIMEOUT = 60 * 1000;